export default "__VITE_ASSET__Dyyo$j6___"